import { observable } from 'mobx';

class PlayerStore {
  @observable supportedLangs = [];
}

export default new PlayerStore();
